import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    waitingAgreements: [],
    waitingAgreementsView: {},
    isLoadingWaitingAgreements: false,
    activeAgreements: [],
    activeAgreementsView: {},
    isLoadingActiveAgreements: false,
    orders: [],
    isLoadingOrders: false,
    ordersView: {},
    notices: [],
    isLoadingNotices: false,
    noticesView: {}
  },
  getters: {
    getNotices: (state) => state.notices,
    getIsLoadingNotices: (state) => state.isLoadingNotices,
    getNoticesView: (state) => state.noticesView,
    getWaitingAgreements: (state) => state.waitingAgreements,
    getIsLoadingWaitingAgreements: (state) => state.isLoadingWaitingAgreements,
    getWaitingAgreementsView: (state) => state.waitingAgreementsView,
    getActiveAgreements: (state) => state.activeAgreements,
    getIsLoadingActiveAgreements: (state) => state.isLoadingActiveAgreements,
    getActiveAgreementsView: (state) => state.activeAgreementsView,
    getOrders: (state) => state.orders,
    getIsLoadingOrders: (state) => state.isLoadingOrders,
    getOrdersView: (state) => state.ordersView
  },
  mutations: {
    setNotices (state, payload) {
      state.notices = payload
    },
    setNoticesView (state, payload) {
      state.noticesView = payload
    },
    toggleLoadingNotices (state) {
      state.isLoadingNotices = !state.isLoadingNotices
    },
    setOrdersView (state, payload) {
      state.ordersView = payload
    },
    setOrders (state, payload) {
      state.orders = payload
    },
    toggleIsLoadingOrders (state) {
      state.isLoadingOrders = !state.isLoadingOrders
    },
    setWaitingAgreements (state, payload) {
      state.waitingAgreements = payload
    },
    setWaitingAgreementsView (state, payload) {
      state.waitingAgreementsView = payload
    },
    setActiveAgreements (state, payload) {
      state.activeAgreements = payload
    },
    setActiveAgreementsView (state, payload) {
      state.activeAgreementsView = payload
    },
    toggleLoadingWaitingAgreements (state) {
      state.isLoadingWaitingAgreements = !state.isLoadingWaitingAgreements
    },
    toggleLoadingActiveAgreements (state) {
      state.isLoadingActiveAgreements = !state.isLoadingActiveAgreements
    }
  },
  actions: {
    async fetchWaitingAgreements ({ commit }, params) {
      let baseParams = {
        decisionUser: [1, 5],
        status: 1
      }
      Object.assign(baseParams, params)
      commit('toggleLoadingWaitingAgreements')
      const response = await new ApiService('e_x_a_b_agreements', baseParams).getResults()
      commit('setWaitingAgreements', await response.items)
      commit('setWaitingAgreementsView', await response.view)
      commit('toggleLoadingWaitingAgreements')
    },
    async fetchActiveAgreements ({ commit }, params) {
      let baseParams = {
        decisionUser: [3, 4, 5],
        status: 3
      }
      Object.assign(baseParams, params)
      commit('toggleLoadingActiveAgreements')
      const response = await new ApiService('e_x_a_b_agreements', baseParams).getResults()
      commit('setActiveAgreements', await response.items)
      commit('setActiveAgreementsView', await response.view)
      commit('toggleLoadingActiveAgreements')
    },
    async fetchOrders ({ commit }, link = 'e_x_s_b_orders') {
      commit('toggleIsLoadingOrders')
      const response = await new ApiService(link).getResults()
      commit('setOrders', await response.items)
      commit('setOrdersView', await response.view)
      commit('toggleIsLoadingOrders')
    },
    async fetchNotices ({ commit }, params) {
      commit('toggleLoadingNotices')
      let baseParams = {}
      Object.assign(baseParams, params)
      const response = await new ApiService('notices', baseParams).getResults()
      commit('setNotices', await response.items)
      commit('setNoticesView', await response.view)
      commit('toggleLoadingNotices')
    }
  }
}
